import { CART_STORAGE_KEY } from 'constants/localStorage';

import { useCookies } from 'react-cookie';
import { useMutation } from 'react-query';

import { CART_STORAGE_KEY as COOKIE_CART_STORAGE_KEY } from '@hooks/cart/useCartId';
import { useHttpService } from '@hooks/useHttpService';

export const useCheckoutCreateFinanceOrderMutation = () => {
  const [, , removeCookie] = useCookies([COOKIE_CART_STORAGE_KEY]);

  const httpService = useHttpService();

  return useMutation(
    async (createPaymentOrderDto: { userId: string; cartId: string }) => {
      const response = await httpService.post('/checkout/create-finance-order', createPaymentOrderDto);

      return response.data;
    },
    {
      onSuccess: () => {
        localStorage.removeItem(CART_STORAGE_KEY);
        removeCookie(COOKIE_CART_STORAGE_KEY, { path: '/', sameSite: 'strict', secure: true });
      },
    }
  );
};
